/* This file was automatically generated by CoralTypeScriptTypesBuildLogic -- do not modify. */
import { CoralClientConfigFactory } from "@amzn/ihm-js-coral-client/client";
/**
 * Coral client configuration factory for TransCustomerFeedbackAggreatorServiceLambda
 */
export const TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory = new CoralClientConfigFactory("TransCustomerFeedbackAggreatorServiceLambda", {
    "Passport.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.prod.passport.transportation.a2z.com/tcfa/",
        },
    },
    "Passport.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.gamma.passport.transportation.a2z.com/tcfa/",
        },
    },
    "Passport.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.beta.passport.transportation.a2z.com/tcfa/",
        },
    },
});
